/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.8.2",
    versionName: "0.2.0-nightly.2025.8.2",
    versionChannel: "nightly",
    buildDate: "2025-08-02T00:07:55.328Z",
    commitHash: "b17865ff2e46946900f4c836a4d4e90cf92af9af",
};
